import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "../../stockTransfers/forms/AddManualPalletForm";
import {LIST_PRODUCTS} from "../../../queries/inventory";
import Loading from "../../../components/Loading";
import GraphQLErrors from "../../../components/GraphQLErrors";
import {cancelAddManualPalletToClientDispatch, successAddManualPalletToClientDispatch} from "../../../actions/ClientDispatchApiActions";
import {fromJS, List, Map} from "immutable";
import {validatePresence} from "../../../lib/Validators";
import {createValidationErrors, createErrors} from "../../../lib/ErrorFormatter";

function validateForm(values) {
  let errors = Map();
  errors = validatePresence(errors, values, "palletId");
  if (!values.get("serialNrs", "").trim() && filledLines(values).size <= 0) {
    errors = errors.set("_error", "Enter serial numbers, or add a line for stock without serials.");
  }
  return errors.toJS();
}

// Lines the admin added but left without a product are ignored.
function filledLines(values) {
  return values.get("lines", List()).filter((line) => line && line.get("sku"));
}

class AddManualPalletFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    const data = {
      clientDispatchId: this.props.clientDispatchId,
      palletId: values.get("palletId"),
      serialNrs: [values.get("serialNrs", "")],
      lines: filledLines(values).toJS(),
    };

    return this.props.addManualPalletToClientDispatch(data)
      .then((response) => {
        if (response.data.addManualPalletToClientDispatch.errors.length <= 0) {
          this.props.successAddManualPalletToClientDispatch();
        } else {
          // Serial problems are keyed by serial number, which no field has, so
          // list them all as the form's error.
          let serverErrors = response.data.addManualPalletToClientDispatch.errors;
          let errors = createValidationErrors(serverErrors, serverErrors.map((error) => error.message).join("\n"));
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });
  }

  handleCancel() {
    this.props.cancelAddManualPalletToClientDispatch();
  }

  render() {
    let {data} = this.props;
    if (data.loading) return <Loading />
    if (data.error) return <GraphQLErrors error={data.error} />
    return (
      <Form
        initialValues={Map({serialNrs: "", lines: List()})}
        products={fromJS(data.products)}
        errors={this.state.errors}
        validate={validateForm}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }
}

const ADD_MANUAL_PALLET_TO_CLIENT_DISPATCH = gql`
  mutation addManualPalletToClientDispatch($data: AddManualPalletToClientDispatchInput!) {
    addManualPalletToClientDispatch(input: $data) {
      errors { key message }
    }
  }
`;

const withQueries = compose(
  graphql(LIST_PRODUCTS, {
    options: (props) => ({
      fetchPolicy: "network-only",
      variables: {}
    })
  }),
  graphql(ADD_MANUAL_PALLET_TO_CLIENT_DISPATCH, {
    props: ({ mutate }) => ({
      addManualPalletToClientDispatch: (data) => mutate({
        variables: { data: data }
      })
    })
  }),
);

export default connect(null, {cancelAddManualPalletToClientDispatch, successAddManualPalletToClientDispatch})(withQueries(AddManualPalletFormContainer));
